module.exports = __webpack_public_path__ + "img/bg-proyectos-8.4ab019db.png";